import { useEffect, useRef } from "react";
import { register, unregister } from "./registry";

interface UseAgentContextOptions {
  key: string;
  label: string;
  value: unknown;
  redact?: string[];
  priority?: number;
}

/**
 * Registers a context entry on mount, replaces it on value change (deep-equal
 * via JSON.stringify), and unregisters on unmount.
 */
export function useAgentContext({ key, label, value, redact, priority = 50 }: UseAgentContextOptions): void {
  const serialisedRef = useRef<string | null>(null);

  useEffect(() => {
    const current = JSON.stringify(value);
    if (current !== serialisedRef.current) {
      serialisedRef.current = current;
      register({ key, label, value, redact, priority, registeredAt: Date.now() });
    }
  });

  // Unregister on unmount
  useEffect(() => {
    return () => {
      unregister(key);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
